export default "__VITE_ASSET__BGWikUbO__"